import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faFilter, faMicroscope, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DataGrid } from "@mui/x-data-grid"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { Box, Drawer } from "@mui/material"
import debounce from 'lodash.debounce';
import { setMcsDetailParams, setMcsNewEntryMode } from "../../state/monthExpEntrySlice"


const RowsField = {
    id: "id",
    detailId: "detailId",
    itemCode: "item_code",
    itemDesc: "Item_Desc",
    rate: "rate"
}
export const InputCell = ({
    row,
    input_id,
    input_type,
    is_readonly,
    holder_text,
    is_required,
    variant,
    color,
    handleInputChange,
    handleKeyDown,
    hanldeBlur,
    gridType
}) => {
    const [localValue, setLocalValue] = useState(row[input_id] ?? "");

    useEffect(() => {

        setLocalValue(row[input_id] ?? "");
    }, [row[input_id]]);

    const onBlur = (e) => {
        if (localValue !== row[input_id]) {
            handleInputChange(row.id, { target: { value: localValue, id: RowsField[input_id] } });
        }

        hanldeBlur(row.id, e);



    };
    const handleChange = (e) => {
        const { id, value } = e.target
        let isValid = true
        if ([RowsField.denier, RowsField.fedNo, RowsField.perMtrWeight, RowsField.wastagePer, RowsField.wastageWeight, RowsField.totalWeight, RowsField.totalPick, RowsField.ends].includes(id))
            isValid = funValidateNoInput(value)
        if (isValid)
            setLocalValue(value)

    }
    return (
        <Input
            isRequired={is_required}
            id={RowsField[input_id]}
            type={input_type}
            size="sm"
            labelPlacement="outside"
            readOnly={is_readonly}
            placeholder={holder_text}
            onKeyDown={(e) => handleKeyDown(row.id, e)}
            value={localValue}
            //onChange={(e) => setLocalValue(e.target.value)}
            onChange={handleChange}
            onBlur={onBlur}
            className="max-w-xs mt-1"
            variant={variant || "bordered"}
            color={color || ""}
        />
    );
};
const YarnRateEntry = () => {
    const { compCode, appType } = useSelector((state) => state.company)
    const { mcsIsNewEntry, mcsDetailParams } = useSelector((state) => state.monthExpEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const gridContainerRef = useRef();
    const [modeSettingParams, setModSettingParams] = useState()
    const [selRowIndex, setSelRowIndex] = useState(0)
    const [deleteOption, setDeleteOption] = useState(false)

    const { isPending: ispendingData, isError: isErrorData, data: yarnData = [], mutate: getData } = usePost({
        url: apiRoute.masterItemEntry.fetchYarnRateList,
        queryKey: "getYarnRateData",
        onSuccessTasks: (data) => {
            console.log(data)
            setRows(data)
        }


    })
    useEffect(() => {
        getData({
            data: {
                comp_code: compCode.join(",")
            }

        })
    }, [])

    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.masterItemEntry.updateItemRate,
        queryKey: "funAddUpdateYarnrateMaster",
        onSuccessTasks: (data) => {
            toast.success(`Submitted Successfully ! `, {
                position: "top-center"
            })
            //setRows([])
            //            setFormData({ ...emptyFormField })
            //navigate(linksUrl.masterItemEntry.masterItemEntryMaster);
        }
    })




    const [deletedItemRows, setDeletedItemRows] = useState([])

    const formField = {

    }
    const [rows, setRows] = useState([])

    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.rate]: "",
    }


    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [


        ],



    }




    const debouncedUpdaterRef = useRef(null);

    const handleInputChange = useCallback((rowId, e) => {
        const { value, id } = e.target;
        if (!debouncedUpdaterRef.current) {

            debouncedUpdaterRef.current = debounce((rowId, id, value) => {
                setRows((prevData) => {
                    const index = prevData.findIndex((row) => row.id === rowId);
                    if (index === -1) return prevData;

                    const updatedRow = {
                        ...prevData[index],
                        [id]: value,
                    };

                    const newData = [...prevData];
                    newData[index] = updatedRow;
                    return newData;
                });
            }, 50);



        }

        debouncedUpdaterRef.current(rowId, id, value);

    }, []);



    const handleKeyDown = (index, event) => {
        setSelRowIndex(index)
        if (event.key === 'Tab') {
            const { value, id } = event.target
            // funGridSetting(value, id, index)


        }
        else {
            if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                return; // Do nothinghanldeBlur
            } else {
                event.stopPropagation(); // Prevent other keys from propagating
            }
        }
    };



    const hanldeBlur = (rowid, e) => {
        const { value, id, name } = e.target


        if (isMobile) {
            setSelRowIndex(rowid)
            // funGridSetting(value, id, rowid)
        }
    }

    console.log(rows)


    const itemGridHeadClass = "bill-grid-style"

    const columns = [
        {
            field: RowsField.id,
            headerName: "No.",
            width: 30,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div className="flex gap-2 font-semibold">
                    {row.id}

                </div>
            ),
        },

        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) =>
                <div>{row[RowsField.itemCode]}</div>
            //renderInputCell(row, RowsField.itemCode, "text", true, "", false, "", ""),

        },
       

   
         {
            field: RowsField.itemName,
            headerName: "Item Name",
            width: 150,
             flex: 1,
            //isVisible:true,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{row[RowsField.itemDesc]}</div>


            ),
        },
     {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 150,
            // flex:1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,

            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.rate}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.weight, "number", false, "", false, "", ""),

        },


    ]



    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }

    const handleAutoCompleteChange = (value, rowid, name) => {


    }
    const funGenGridRows = (no_ofrows) => {


        let newRowsId = rows.length + 1
        const newRow = {
            id: newRowsId, ...initialRow
        }
        setRows([...rows, newRow])
        setTimeout(() => {
            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }
        }, 250)
        setTimeout(() => {
            const firstCell = gridContainerRef.current?.querySelector(
                `[data-id="${newRowsId}"] [data-field="id"]`
            );
            if (firstCell) {
                firstCell.focus();
            }
        }, 500);

    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {

                if (rows[i].acId == "" || rows[i].acId == null) {
                    if (!msg.includes("Account"))
                        msg = msg + "  Account ,";
                    no = 1
                }
                if (rows[i].amount == "" || rows[i].amount == "0") {
                    if (i != rows.length - 1) {
                        if (!msg.includes("Amount"))
                            msg = msg + " Amount ,";
                        no = 1
                    }

                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        if (formData[formField.costMonth].trim() === "" || formData[formField.costMonth] == "0") {
            newErrors[formField.costMonth] = "Month is required"
        }
        if (formData[formField.costYear].trim() === "" || formData[formField.costYear] == "0") {
            newErrors[formField.costYear] = "Year is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    // useEffect(() => {
    //     validateForm();
    // }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()


        //const grid_msg = ValidateGrid();
       // const validate_form = validateForm()
        //grid_msg == "" && 
        if (rows && rows.length > 0) {
            // let rowData = rows;
            // if (rows.length > 1) {
            //     let last_inx = rows.length - 1
            //     if (rows[last_inx].amount == "0" || rows[last_inx - 1].amount == "") {
            //         rowData = rows.slice(0, last_inx)
            //     }
            // }

            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: rows,
                    login_user: user.username
                }
            })
        }
        else {
            toast.error("No  Data Found ", {
                "position": "top-center"
            })
        }

    }

    const handleDeleteRow = (id) => {
        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        setRows(updatedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }






    const handleClickPrev = () => {
        setRows(yarnData);
       // setFormData({ ...emptyFormField })
        // navigate(linksUrl.masterItemEntry.masterItemEntryMaster)
    }
    const handleAddRow = () => {

        funGenGridRows(1)
    }

    useEffect(() => {
        if (rows && rows.length <= 0)
            setFormData({ ...formData, [formField.costYear]: "" })
    }, [rows])

    const totalAmount = rows.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );

    //console.log(mcsIsNewEntry, mcsDetailParams)
    // if (isPending || isPendingDel) {
    //     return <LoadingCard />;
    // }
    const handleDeleteEntry = () => {
        // funDelete({
        //     data: {
        //         compcode: compCode.join(","),
        //         year: formData[formField.costYear],
        //         month: formData[formField.costMonth]
        //     }
        // })

    }

    if (isError || isErrorData) {
        return <ErrorCard />;
    }
    if (ispendingData || isPending) {
        return <LoadingCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${mcsIsNewEntry ? "" : ""} Yarn And Fabric Cost Rate  `}
                breadcrumbs={["Items/Product", "Yarn And Fabric Cost Rate "]}
            // prevPage={{
            //     show: true,
            //     onClick: handleClickPrev,
            // }}
            >

                <div shadow="sm" className="mb-3 w-full">

                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <Autocomplete
                                                        size="md"
                                                        name={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        placeholder={item.placeholder}
                                                        menuTrigger="input"
                                                        isRequired={item.isrequired}
                                                       // isLoading={isLoading}
                                                        className="max-w-23 font-semibold"
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                        isClearable={false}
                                                        isVirtualized
                                                        //isDisabled={item.name == formField.costMonth ? rows && rows.length > 0 ? false : true : false}
                                                        // isReadOnly={mcsIsNewEntry ? false : true}
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, "", item.name, "")
                                                        }
                                                        color="warning"
                                                        //onChange={handleFormSelectionChange}
                                                        selectedKey={formData[item.name]}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>


                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.name]:
                                                                                dayjs(newValue).format("YYYY-MM-DD"),

                                                                        };
                                                                    });
                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: { size: "small", required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (
                                                    <Input
                                                        type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        //aria-label={item.placeholder}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={formData[item.name]}
                                                        variant="bordered"
                                                        //disabled={mcsIsNewEntry ? false : true}
                                                        onChange={(e) => handleChange(e)}
                                                        onBlur={(e) => hanldeBlur("", e)}
                                                        //isReadOnly={item.name == formField.challanNo ? true : false}
                                                        //  readOnly={item.name == formField.voucherNo ? true : false}
                                                        size={"md"}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    ></Input>
                                                )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }
                        <div className="mt-5">
                            {/* <div>
                                <Button size="sm" color="success" className="text-white  font-semibold uppercase" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow"
                                    onPress={handleAddRow}>
                                    ADD
                                </Button>
                            </div> */}

                            {yarnData && yarnData?.length > 0 ? (
                                <div>

                                    <Box ref={gridContainerRef} sx={{
                                 //   overflow: "scroll",
                                      //  height:   rows.length > 10 ? 500 : "auto",
                                        width: '100%',
                                    }}>
                                        {/* style={{ height: 50+ Number(rows.length * 51), width: "100%", maxHeight: "500px", overflow: "auto" }}> */}
                                        <DataGrid
                                            // ref={gridContainerRef}
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            hideFooterPagination= {false}//{rows && rows.length > 100 ? false : true}
                                            hideFooter= {false }//{rows && rows.length > 100 ? false : true}
                                            columnHeaderHeight={40}
                                            disableColumnMenu={false}
                                            rowHeight={45}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    fontWeight: "bold",
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .MuiDataGrid-menuIcon': {
                                                    visibility: 'visible',
                                                    opacity: 1,
                                                    width: 'auto',
                                                },
                                                // '& .MuiDataGrid-menuIcon button': {

                                                //     backgroundColor: "#ffffff",
                                                // },
                                                '& .MuiDataGrid-menuIcon svg': {
                                                    color: '#fffcfcff',

                                                },
                                                "& .MuiDataGrid-columnHeaderTitle": {
                                                    whiteSpace: "normal",
                                                    lineHeight: "1.5",
                                                    textAlign: "center",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                },
                                                "& .MuiDataGrid-columnHeader": {
                                                    height: "auto !important",
                                                },
                                                "& .MuiDataGrid-columnHeaders": {
                                                    maxHeight: "none !important",
                                                },

                                            }}
                                            disableColumnSorting={true}
                                        />
                                    </Box>
                                    <div className="justify-center flex gap-5 mt-5">
                                        <Button
                                            color="primary"
                                            type="submit"
                                            size="sm"
                                            variant="shadow"
                                            isLoading={isPending}
                                            // isDisabled={isPendingDel}
                                            startContent={<FontAwesomeIcon icon={faSave} />}
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            color="danger"
                                            variant="shadow"
                                            size="sm"
                                            onPress={handleClickPrev}
                                            startContent={<FontAwesomeIcon icon={faCancel} />}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-gray-600 text-center "> No Data found</div>
                            )}
                        </div>



                    </form>

                </div>
            </MainContainer>
        </div>
    )

}
export default YarnRateEntry